import { useEffect } from "react";
import {
  fetchOdooLiveChatIdentityToken,
  subscribeOdooLiveChatLoad,
  whenOdooLiveChatReady
} from "services/odoo-live-chat/odoo-live-chat";
import { useAuth } from "stores/auth/auth-context";

// Hands the agent a verified identity for logged-in users. The token comes
// from our server (not browser cookies) and is verified by Odoo.
export const useOdooLiveChatIdentify = () => {
  const { user } = useAuth();
  const isLoggedIn = user?.isUserLoggedIn || false;

  useEffect(() => {
    if (!isLoggedIn) return;

    let isCancelled = false;
    let removeReadyListener: () => void = () => undefined;

    // Only fetch the token once the widget is being loaded; it calls the
    // backend, so doing it on every page view would add load for nothing.
    const removeLoadListener = subscribeOdooLiveChatLoad(() => {
      fetchOdooLiveChatIdentityToken().then((token) => {
        if (isCancelled || !token) return;
        removeReadyListener = whenOdooLiveChatReady((api) => {
          api.setIdentity(token);
        });
      });
    });

    return () => {
      isCancelled = true;
      removeLoadListener();
      removeReadyListener();
    };
  }, [isLoggedIn]);
};
